import { render, staticRenderFns } from "./Holdingtable.vue?vue&type=template&id=1b4a197e&lang=html&"
import script from "./Holdingtable.vue?vue&type=script&lang=js&"
export * from "./Holdingtable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports